var exports = {
  "ns": "Attachment.module__attachmentWrapper___R2tBSG",
  "yf": "Attachment.module__expiredOverlay___R2tBSG",
  "ri": "Attachment.module__expiredContent___R2tBSG",
};

module.exports = exports;
